// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getAppliedDeliveryFee } from '~shared/features/shipment-fees/selectors/getAppliedDeliveryFee';

export const getHasAppliedDeliveryFee = createSelector([getAppliedDeliveryFee], (appliedDeliveryFee) => {
  return !!appliedDeliveryFee && parseFloat(appliedDeliveryFee.amount) > 0;
});
